import React from 'react'
import { useField, FieldConfig } from 'formik'
import { FormControl, TextField, TextFieldProps } from '@mui/material'
import { FieldLabel } from '../FieldLabel/FieldLabel'
import { FieldError } from '../FieldError/FieldError'

interface IFieldInputProps extends FieldConfig {
  label?: string
  required?: boolean
}
export function FieldText({ name, label, required, ...props }: IFieldInputProps & TextFieldProps) {
  const [field, meta] = useField(name)

  return (
    <FormControl className="field-container" fullWidth={ props.fullWidth }>
      {label && <FieldLabel required={required}>{label}</FieldLabel>}
      <TextField {...props} {...field} />
      {!!meta.touched && !!meta.error && <FieldError>{meta.error}</FieldError>}
    </FormControl>
  )
}

FieldText.defaultProps = {
  label: '',
  required: false,
}
